import styled from '@emotion/styled';
import { Section } from '../../Section/Section';
import { SignUpForm } from '../../SignUpForm/SignUpForm';
import { SectionName } from '../../../observability/tracking/events';
import { COLOR_KEYS } from '../../../constants';
import { Background } from '../../Section/background';

type Props = {
  heading: string;
  subheading: string;
  background: Background;
  hideFieldsUntilFocus?: boolean;
  facebookSSOEnabled?: boolean;
  googleSSOEnabled?: boolean;
  microsoftSSOEnabled?: boolean;
};

export function SignUpCtaSection({
  background,
  facebookSSOEnabled = true,
  googleSSOEnabled = true,
  heading,
  hideFieldsUntilFocus = true,
  microsoftSSOEnabled = true,
  subheading,
}: Props) {
  const getBackground = () => {
    const colorMap: Partial<Record<Background, Background>> = {
      Lava40Dotty: COLOR_KEYS.zapier,
      lava60: COLOR_KEYS.zapier,
      ocean10: COLOR_KEYS.night,
      Sun60Dotty: COLOR_KEYS.moss,
    };

    return Object.prototype.hasOwnProperty.call(colorMap, background)
      ? colorMap[background]
      : background;
  };

  return (
    <Section
      background={getBackground()}
      heading={heading}
      sectionToTrack={SectionName.SignUpSection}
      subheading={subheading}
    >
      <Content>
        <SignUpForm
          facebookSSOEnabled={facebookSSOEnabled}
          googleSSOEnabled={googleSSOEnabled}
          hideFieldsUntilFocus={hideFieldsUntilFocus}
          microsoftSSOEnabled={microsoftSSOEnabled}
        />
      </Content>
    </Section>
  );
}
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
